import * as React from "react";
import { ContainerWrapper } from 'src/components/common/ContainerWrapper/ContainerWrapper';
import "./PasswordRecover.scss";
import ChangePasswordByCode from './ChangePasswordByCode';
import RequestRecoveryCode from './RequestRecoveryCode';

function PasswordRecover() {
    const [email, setEmail] = React.useState("");

    return (
        <div className="password-recover-page">
            <ContainerWrapper className="password-recover">
                {email &&
                    <ChangePasswordByCode email={email} />
                    ||
                    <RequestRecoveryCode onConfirmed={(e) => setEmail(e)} />
                }
            </ContainerWrapper>
        </div>
    );
}
export default PasswordRecover;



// WEBPACK FOOTER //
// ./src/pages/password-recover/PasswordRecover.tsx